export const formatTerritoriesOptionText = ({
  id,
  name,
}: {
  id: string;
  name: string;
}): string => `${id} - ${name}`;
